import React from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';

// import Details from './Detail';
import Overview from './Overview';
import New from './New';
import Modal from '../../components/Modal';

const Visits = props => {
  const paths = {
    new: `${props.match.path}/new`,
    details: `${props.match.path}/:userId`,
    search: `${props.match.path}/search/:search?`,
  };

  return (
    <Modal title='Besuchstermine'>
      <Switch>
        {/* 
        <Route path={paths.details} component={Details} /> */}
        <Route path={paths.new} component={New} />
        <Route path={paths.search} component={Overview} />
        <Route component={Overview} />
      </Switch>
    </Modal>
  );
};

export default withRouter(Visits);
